import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Scorecard art: one card and nothing else. A caption, a large figure and a
 * green change badge, with a sparkline along the bottom.
 */
export function ScorecardArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect
        x={20}
        y={14}
        width={120}
        height={72}
        rx={5}
        fill="hsl(var(--foreground) / 0.06)"
        stroke="hsl(var(--muted-foreground) / 0.22)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <rect x={34} y={26} width={40} height={4} rx={2} fill="hsl(var(--foreground) / 0.14)" />
      <rect x={34} y={36} width={62} height={18} rx={3} fill="hsl(var(--foreground) / 0.3)" />
      <rect x={102} y={40} width={24} height={10} rx={3} fill="hsl(var(--positive) / 0.4)" />
      {/* Sparkline along the bottom of the card. */}
      <path
        d="M34 72 L44 68 L54 70 L64 62 L74 65 L84 58 L94 61 L104 66 L114 64 L126 71"
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
